var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"dblclick":_vm.handleDblClick,"click":_vm.handleClick}},[_c('iframe',{style:(_vm.styleChartName),attrs:{"src":_vm.dataChart.value,"draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }